import { render, staticRenderFns } from "./NgDrawer.vue?vue&type=template&id=3f91bfb4&scoped=true&"
import script from "./NgDrawer.vue?vue&type=script&lang=js&"
export * from "./NgDrawer.vue?vue&type=script&lang=js&"
import style0 from "./NgDrawer.vue?vue&type=style&index=0&id=3f91bfb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f91bfb4",
  null
  
)

export default component.exports